import { FILESPACE_CLIENT_QUERY_KEYS } from '#constants';
const FILESPACE_ENTRY_PATH_BASE = FILESPACE_CLIENT_QUERY_KEYS.FilespaceDirectoryPath;
export const FilespaceEntryPathKeyFactory = {
    all: () => [FILESPACE_ENTRY_PATH_BASE],
    exact: (filespaceId, fsEntryId) => [
        ...FilespaceEntryPathKeyFactory.all(),
        filespaceId,
        fsEntryId,
    ],
};
